module.exports = __webpack_public_path__ + "static/media/image-0.9857282f.png";